import React from 'react'
import { default as FooterComponent } from '@organisms/Footer/Footer'
import { FooterProps } from '@organisms/Footer/Footer.types'

const Footer = ({ regions }: FooterProps) => {
  return <FooterComponent regions={regions} />
}

export default Footer
